import { ConditionPredicate } from 'xstate';

import { MicroEstimationContext, MicroEstimationtEvent } from '.';

export enum MicroEstimationGuard {
  ShouldSkipTaxFrequency = 'shouldSkipTaxFrequency',
  ShouldSkipTaxType = 'shouldSkipTaxType',
  HasDoneInitialEstimation = 'hasDoneInitialEstimation',
  ShouldOnlyDisplayRevenueSituation = 'shouldOnlyDisplayRevenueSituation',
}

export const microEstimationGuards = {
  hasDoneInitialEstimation: (context) =>
    Boolean(context.taxForecastProfile?.hasCustomizedEstimation),
  shouldOnlyDisplayRevenueSituation: (context) =>
    Boolean(context.isRevenueEdit),
  shouldSkipTaxFrequency: (context) =>
    Boolean(context.companyProfile.taxFrequency),
  shouldSkipTaxType: (context) => Boolean(context.companyProfile.hasPrelevLib),
} satisfies Record<
  MicroEstimationGuard,
  ConditionPredicate<MicroEstimationContext, MicroEstimationtEvent>
>;
